var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrivals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28125 5.21875C4.09375 5.01042 4 4.77083 4 4.5C4 4.22917 4.09375 3.98958 4.28125 3.78125C4.51042 3.59375 4.75 3.5 5 3.5C5.25 3.5 5.48958 3.59375 5.71875 3.78125L14 12.0938V8.5C14 8.20833 14.0938 7.96875 14.2812 7.78125C14.4688 7.59375 14.7083 7.5 15 7.5C15.2917 7.5 15.5312 7.59375 15.7188 7.78125C15.9062 7.96875 16 8.20833 16 8.5V14.5C16 14.5833 15.9792 14.7083 15.9375 14.875C15.7708 15.2917 15.4583 15.5 15 15.5H9C8.70833 15.5 8.46875 15.4062 8.28125 15.2188C8.09375 15.0312 8 14.7917 8 14.5C8 14.2083 8.09375 13.9688 8.28125 13.7812C8.46875 13.5938 8.70833 13.5 9 13.5H12.5938L4.28125 5.21875Z",
    fill: "#005EB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrivals);
export default __webpack_public_path__ + "static/media/arrivals.44338ed795f47011cbda3532d3c301b4.svg";
export { ForwardRef as ReactComponent };